"use client";

// Client boundary for the legacy Home sections that are deferred from the
// App Router migration. They read legacy AppContext (and, for some, Apollo)
// provided by the surrounding DeferredHomeSlot adapter, and used to inherit
// BitcasinoHome's "use client" directive, which the native server Home no
// longer provides.
export { default as Tournaments } from "@casino/legacy/client/features/Tournaments";
